import initialState from './initialState'
import * as types from '../actions/actionTypes'

export default function requests(state = initialState.assets, action: any) {
  switch (action.type) {
    case types.LOAD_ASSET_SUCCESS:
      return action.assets
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/reducers/assetReducer.tsx